<div class="wm">
  <!-- Slide track. Native scroll-snap rather than a carousel library: it gives
       real momentum swiping on device for no bundle cost, and the dots/Next
       button just drive scrollLeft. -->
  <div
    #track
    class="wm-track"
    (scroll)="onScroll()"
    data-testid="onboarding-track"
    role="group"
    [attr.aria-label]="'Welcome, ' + slides.length + ' slides'"
  >
    @for (s of slides; track s.eyebrow; let i = $index) {
      <section
        class="wm-slide"
        role="group"
        [attr.aria-roledescription]="'slide'"
        [attr.aria-label]="i + 1 + ' of ' + slides.length"
      >
        <div class="wm-hero">
          <img
            [src]="s.image"
            [alt]="s.imageAlt"
            class="wm-hero-img"
            [attr.fetchpriority]="i === 0 ? 'high' : null"
            decoding="async"
          />
          <div class="wm-scrim" aria-hidden="true"></div>
        </div>

        <div class="wm-body">
          <p class="wm-eyebrow">{{ s.eyebrow }}</p>
          <h1 class="wm-title">{{ s.titleLead }}<span class="wm-accent">{{ s.titleAccent }}</span></h1>
          <p class="wm-text">{{ s.body }}</p>

          @if (s.stats) {
            <div class="wm-stats">
              @for (st of s.stats; track st.label) {
                <div class="wm-stat">
                  <div class="wm-stat-n">{{ st.value }}</div>
                  <div class="wm-stat-l">{{ st.label }}</div>
                </div>
              }
            </div>
          }
        </div>
      </section>
    }
  </div>

  <!-- Skip floats over the hero; hidden on the last slide, where the two
       explicit CTAs already cover "no thanks". -->
  @if (!isLast()) {
    <button
      type="button"
      class="wm-skip"
      (click)="dismiss()"
      data-testid="onboarding-skip"
    >
      {{ Cta.Skip }}
    </button>
  }

  <footer class="wm-footer">
    <div class="wm-dots" role="tablist" [attr.aria-label]="'Slide'">
      @for (s of slides; track s.eyebrow; let i = $index) {
        <button
          type="button"
          class="wm-dot"
          [class.is-active]="i === index()"
          [attr.aria-label]="'Go to slide ' + (i + 1)"
          [attr.aria-selected]="i === index()"
          role="tab"
          (click)="goTo(i)"
        ></button>
      }
    </div>

    @if (isLast()) {
      <div class="wm-final">
        <ion-button
          expand="block"
          class="wm-btn"
          (click)="startTour()"
          data-testid="onboarding-start-tour"
        >
          <ion-icon name="sparkles-outline" slot="start" aria-hidden="true"></ion-icon>
          {{ Cta.StartTour }}
        </ion-button>
        <ion-button
          expand="block"
          fill="clear"
          size="small"
          class="wm-btn-secondary"
          (click)="dismiss()"
          data-testid="onboarding-explore"
        >
          {{ Cta.Explore }}
        </ion-button>
      </div>
    } @else {
      <ion-button
        class="wm-btn"
        (click)="next()"
        data-testid="onboarding-next"
      >
        {{ Cta.Next }}
        <ion-icon name="arrow-forward" slot="end" aria-hidden="true"></ion-icon>
      </ion-button>
    }
  </footer>
</div>
